/**
 * Home hero LCP image descriptors.
 * Keep `client/index.html` preload (imagesrcset + imagesizes + href) in sync with these values.
 */
export const HERO_SRCSET =
  "/images/hero/matt-rebeiro-hero-400.avif 400w, /images/hero/matt-rebeiro-hero-560.avif 560w, /images/hero/matt-rebeiro-hero-682.avif 682w";

/** Matches `max-w-7xl` padding: `px-4` below sm, `sm:px-6` from sm up; image `max-w-[450px]`. */
export const HERO_SIZES =
  "(max-width: 639px) min(calc(100vw - 2rem), 450px), (max-width: 1023px) min(calc(100vw - 3rem), 450px), 450px";

/** Fallback `src` when srcset is unsupported; should be the largest variant. */
export const HERO_IMG_FALLBACK_SRC = "/images/hero/matt-rebeiro-hero-682.avif";
